import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DeviceIds, FeatureCommands, FeatureNames, FeaturePropertyKey } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { InstallationService } from '../../../../../../services/installation.service';

@Component({
  selector: 'app-src-not-added-other-room',
  templateUrl: './src-not-added-other-room.component.html',
  styleUrls: ['./src-not-added-other-room.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcNotAddedOtherRoomComponent implements OnInit, OnDestroy {
  @Input() heatingCircuit: string;
  @Input() isAddCommandExecutable: boolean;
  @Input() enabled: boolean;

  heatingCircuitName: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public installationService: InstallationService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.installationService
      .getCircuitName(this.heatingCircuit, true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((heatingCircuitName: string) => (this.heatingCircuitName = heatingCircuitName));
  }

  addOtherRoom(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.otherRooms,
      [Number(this.heatingCircuit), this.heatingCircuitName],
      null,
      [FeaturePropertyKey.heatingCircuit, FeaturePropertyKey.name],
      FeatureCommands.add,
      null,
      DeviceIds.RoomControl
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
